export const VehicleAssignmentsResource = {
  name: "Vehicle Assignments",
  path: "/fleets/vehicle-assignments",
  access: ["read-vehicleAssignments"],
};
